/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {ActivitySearchIdsRequest} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'
import {ActivitySearchIdsResponse} from '@cash-web/protos/squareup/cash/activity/api/v1/search.pb'


export const activitySearchIds = (request:ActivitySearchIdsRequest, options?: CashRequestOptions) => post<ActivitySearchIdsRequest, ActivitySearchIdsResponse>("/2.0/cash/activity-search-ids", request, {...options, rejectOnError: true })